var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/notification-bing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0232 2.3335C9.72988 2.3335 6.25321 5.81016 6.25321 10.1035V12.5535C6.25321 13.3468 5.92655 14.5368 5.51821 15.2135L4.03655 17.6868C3.12655 19.2152 3.75655 20.9185 5.43655 21.4785C11.0132 23.3335 17.0449 23.3335 22.6215 21.4785C24.1965 20.9535 24.8732 19.1102 24.0215 17.6868L22.5399 15.2135C22.1315 14.5368 21.8049 13.3352 21.8049 12.5535V10.1035C21.7932 5.8335 18.2932 2.3335 14.0232 2.3335Z",
    stroke: "#00AB55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.885 21.9565C17.885 24.0915 16.135 25.8415 14 25.8415C12.9383 25.8415 11.9583 25.3982 11.2583 24.6982C10.5583 23.9982 10.115 23.0182 10.115 21.9565",
    stroke: "#00AB55",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.43d6ddb318280d807ffcf087234d8c86.svg";
export { ForwardRef as ReactComponent };